export default __webpack_public_path__ + "static/yoota-779228fac373ca793514df22163c995a.png";